import React from 'react';
import Footer from '../Footer';
import GoToTop from '../GoToTop/GoToTop';
import "./privacypolicy.css"

function PrivacyPolicy() {


    return (
        <div>
            <div className="p-6 max-w-4xl mx-auto text-gray-800 space-y-6 policy">
                <h1 className="text-3xl font-bold border-b pb-2">Privacy Policy</h1>
                <br />
                <section>
                    <h2 className="text-xl font-semibold">1. Introduction</h2>
                    <p>
                        KibbCom India ("we," "our," or "us") values your privacy and is committed to protecting your personal data.
                        This Privacy Policy explains how we collect, use, and safeguard information obtained through LinkedIn ads and lead forms.
                        By interacting with our LinkedIn ads, or/and our lead forms you consent to the practices described in this policy.
                    </p>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">2. Information We Collect</h2>
                    <p>When you engage with our LinkedIn ads or/and lead forms, we may collect the following types of information:</p>
                    <ul className="list-disc ml-6 space-y-1">
                        <li><strong>Personal Information:</strong> Name, email address, phone number, job title, company name, and LinkedIn profile data (if shared via LinkedIn lead forms).</li>
                        <li><strong>Behavioral Data:</strong> Ad interactions and engagement metrics such as clicks, views, and conversions.</li>
                        <li><strong>Technical Information:</strong> IP address, browser type, and LinkedIn-generated insights.</li>
                    </ul>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">3. How We Use Your Information</h2>
                    <ul className="list-disc ml-6 space-y-1">
                        <li>Provide requested services, whitepapers, or newsletters.</li>
                        <li>Follow up on inquiries or leads submitted via LinkedIn lead forms.</li>
                        <li>Improve our advertising strategies and personalize future campaigns.</li>
                        <li>Conduct analytics and measure ad performance.</li>
                        <li>Communicate marketing offers relevant to your business interests.</li>
                    </ul>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">4. Data Sharing & Third Parties</h2>
                    <p>
                        We do not sell, rent, or trade your personal data. However, we may share your information with:
                    </p>
                    <ul className="list-disc ml-6 space-y-1">
                        <li><strong>LinkedIn:</strong> For ad optimization and performance tracking.</li>
                        <li><strong>CRM & Marketing Platforms:</strong> (e.g., HubSpot, Salesforce) to manage leads and communication.</li>
                        <li><strong>Analytics Providers:</strong> (e.g., Google Analytics, LinkedIn Insights) to evaluate ad effectiveness.</li>
                        <li><strong>Service Providers:</strong> Assisting with IT infrastructure, cloud storage, or security.</li>
                    </ul>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">5. Data Storage & Security</h2>
                    <p>
                        We implement security measures to protect your data from unauthorized access, loss, or misuse.
                        Your data is stored securely and retained only for as long as necessary for the intended purpose,
                        after which it is securely deleted or anonymized.
                    </p>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">6. Your Rights & Choices</h2>
                    <ul className="list-disc ml-6 space-y-1">
                        <li><strong>Access & Update:</strong> Request a copy of the personal data we hold about you.</li>
                        <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time.</li>
                        <li><strong>Data Deletion:</strong> Request deletion of your data, subject to legal obligations.</li>
                        <li><strong>Restrict Processing:</strong> Limit how we use your information for specific purposes.</li>
                    </ul>
                    <p>To exercise any of these rights, contact us at <a href="mailto:info@kibbcom.in" className="text-blue-600 underline">info@kibbcom.in</a>.</p>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">7. Cookies & Tracking Technologies</h2>
                    <p>
                        We may use LinkedIn tracking pixels and cookies to analyse ad performance.
                        You can manage or disable tracking through LinkedIn's privacy settings or your browser settings.
                        Learn more by visiting LinkedIn’s Cookie Policy.
                    </p>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">8. Changes to This Policy</h2>
                    <p>
                        We may update this policy periodically to reflect legal or business changes.
                        We encourage you to review this page regularly for any updates.
                    </p>
                </section>



                <section>
                    <h2 className="text-xl font-semibold">9. Contact Information</h2>
                    <p>
                        For questions or concerns regarding this Privacy Policy, please contact:
                    </p>
                    <address className="not-italic">
                        <strong>KibbCom India</strong><br />
                        No.43/2, Munnireddy Complex, 3rd Floor<br />
                        Opposite Kundalahalli Gate,<br />
                        Varthur Main Road, Marathahalli Post,<br />
                        Bangalore-560037, Karnataka, India<br />
                        Email: <a href="mailto:info@kibbcom.in" className="text-blue-600 underline">info@kibbcom.in</a><br />
                        Phone: <a href="tel:+919108290838" className="text-blue-600 underline">+91-9108290838</a>
                    </address>
                </section>
            </div>
            <Footer />
            <GoToTop />

        </div>
    );
}
export default PrivacyPolicy;